module.exports = __webpack_public_path__ + "img/1280-px-pay-pal-svg@2x.ee4b0b7f.png";